var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcExpand(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear_6980_186731)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6980_186731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8805 18.7075L16.0005 14.8275L12.1205 18.7075C11.7305 19.0975 11.1005 19.0975 10.7105 18.7075C10.3205 18.3175 10.3205 17.6875 10.7105 17.2975L15.3005 12.7075C15.6905 12.3175 16.3205 12.3175 16.7105 12.7075L21.3005 17.2975C21.6905 17.6875 21.6905 18.3175 21.3005 18.7075C20.9105 19.0875 20.2705 19.0975 19.8805 18.7075V18.7075Z",
    fill: "url(#paint1_linear_6980_186731)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6980_186731",
    x1: 48,
    y1: -12.3333,
    x2: -5.11175,
    y2: -4.99452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE8AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6980_186731",
    x1: 21.5919,
    y1: 15.7386,
    x2: 9.83771,
    y2: 15.7386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005887"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6980_186731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 4 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExpand);
export default __webpack_public_path__ + "static/media/ic_expand.78927dc9e929964b585f7433c1fccfe3.svg";
export { ForwardRef as ReactComponent };